// extracted by mini-css-extract-plugin
export default {"dlMarkupText":"src-js-common-components-dynamic-MarkupText---dlMarkupText---aY0tM","dlRenderedDocument":"dlRenderedDocument","dlRenderedPage":"dlRenderedPage"};